<div class="modal-header">
  <div>
    <h4 class="modal-title mb-1" translate>EVENT.EDIT_DATES</h4>
    <small class="text-muted" translate>EVENT.EDIT_DATES_SUBTITLE</small>
  </div>
  <button
    type="button"
    class="close"
    [attr.aria-label]="'CLOSE' | translate"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form [formGroup]="editEventDateForm" (ngSubmit)="onSubmit()">
  <div class="modal-body">
    <div class="date-summary">
      <div>
        <span class="summary-label" translate>EVENT.CURRENT_PERIOD</span>
        <strong>{{ currentStartDate }} - {{ currentFinalDate }}</strong>
      </div>
      <div>
        <span class="summary-label" translate>EVENT.DURATION</span>
        <strong>
          {{ eventDaysCount }}
          {{ (eventDaysCount === 1 ? "EVENT.DAY_SINGULAR" : "EVENT.DAY_PLURAL") | translate }}
        </strong>
      </div>
    </div>

    <div class="form-group">
      <label for="eventStartDate" translate>EVENT.NEW_START_DATE</label>
      <input
        id="eventStartDate"
        type="date"
        formControlName="startDate"
        class="form-control"
        [min]="minDate"
      />
      <small class="form-text text-muted" translate>EVENT.TODAY_OR_FUTURE_DATE_ONLY</small>
      <div class="alert alert-danger mt-2" *ngIf="submitted && f.startDate.invalid">
        <small *ngIf="f.startDate.errors?.required" translate>DATE_REQUIRED</small>
        <small *ngIf="f.startDate.errors?.pastDate" translate>EVENT.DATE_CANNOT_BE_BEFORE_TODAY</small>
      </div>
    </div>

    <div class="date-preview" *ngIf="previewStartDate && previewFinalDate">
      <span class="summary-label" translate>EVENT.NEW_PERIOD</span>
      <strong>{{ previewStartDate }} - {{ previewFinalDate }}</strong>
      <div class="preview-days">
        <span *ngFor="let day of previewEventDays; let i = index">
          {{ "EVENT.DAY" | translate }} {{ i + 1 }}: {{ day | date: "dd/MM/yyyy" }}
        </span>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-dark"
      (click)="activeModal.close('Close click')"
      translate
    >
      CLOSE
    </button>
    <button
      type="submit"
      class="btn btn-sm-block btn-gradient-primary mr-2 float-right"
      [disabled]="editEventDateForm.invalid || submitted"
      translate
    >
      SAVE
    </button>
  </div>
</form>
